const errorMessage = reason => {
  if (typeof reason === 'string') return reason;

  return (
    reason?.response?.data?.message ||
    reason?.response?.data?.error ||
    reason?.response?.data?.errors?.[0] ||
    ''
  );
};

export const summarizeBatchVisitConfirmation = (ids, results) => {
  const confirmedIds = [];
  const failedIds = [];
  const errors = [];

  results.forEach((result, index) => {
    if (result.status === 'fulfilled') {
      confirmedIds.push(ids[index]);
      return;
    }

    failedIds.push(ids[index]);
    const message = errorMessage(result.reason);
    if (message && !errors.includes(message)) errors.push(message);
  });

  return { confirmedIds, failedIds, errors };
};
